import React, { Component } from "react";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import ModalPortal from "./ModalPortal";

export default class GalleryItemModal extends Component {
  constructor(props) {
    super(props);
    const p = props.item || { idFoto: null, imageUuid: null, imageBase64: "", externalId: "" };
    this.state = {
      item: { ...p },
    };
  }

  componentDidMount() {
    document.body.classList.add("modal-open");
  }
  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  onField = (k, v) => this.setState((s) => ({ item: { ...s.item, [k]: v } }));

  handleSave = () => {
    const { onSave } = this.props;
    const { item } = this.state;
    const { isCover, ...clean } = item || {};
    onSave?.(clean);
  };

  render() {
    const { onClose, onDelete } = this.props;
    const { item } = this.state;

    return (
      <ModalPortal>
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <h4>Editar foto</h4>

            <div className="mb-3" style={{ width: "100%", maxWidth: 420, margin: "0 auto" }}>
              <MfmImageUploader
                uuid={item.imageUuid || null}
                appCode="MUGIN"
                library="fotos"
                size="medium"
                mediaType="image"
                allowPicker
                onUpload={(result) => this.setState((s) => ({ item: { ...s.item, imageUuid: result.uuid, imageBase64: null } }))}
                onDelete={() => this.setState((s) => ({ item: { ...s.item, imageUuid: null } }))}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">External ID (autogenerado)</label>
              <input className="form-control" value={item.externalId || ""} readOnly disabled />
            </div>

            <div className="modal-actions">
              {onDelete && (
                <button className="btn btn-outline-danger" onClick={onDelete}>Eliminar</button>
              )}
              <div style={{ flex: 1 }} />
              <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
              <button className="btn btn-primary" onClick={this.handleSave}>Guardar</button>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}
